module.exports = __webpack_public_path__ + "static/img/xueliumajiang.f49a3e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/xueliumajiang.jpg
// module id = C//j
// module chunks = 0